import { getClassicApiEndpoint } from 'constants/api'
import auth from 'modules/auth'

const avatarUploadAPI = {
  uploadAvatar: async (dataURL: any): Promise<any> => {
    let form = new FormData()
    form.append('file', dataURL)
    const res = await auth.fetch(`${getClassicApiEndpoint()}v2/User/UpdateImageForCurrentUser`, {
      method: 'POST',
      body: form,
    })
    if (res.ok) {
      return res.json()
    }
    if (!res.ok) {
      throw Error(`Failed to upload image`)
    }
  },
}

export default avatarUploadAPI
